import printJS from 'print-js';
import api from './AxiosInstance';
import photoApi from './PhotoAxiosInstance';
import { api_URL } from './Constantes';

export class MesServices {
  //Changement de mot de passe 

  updateMdp = async (payload) => {
    try {
      const response = await api.put(`User/portail/updatePwd`, payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };

  /* .......................................................................... */
  getDocsPart = async (numcont, selectedYear) => {
    try {
      const response = await api.get(`Document/ByPartExt?matricule=${numcont}&annee=${selectedYear}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };

  getDocExercice = async (numcont) => {
    try {
      const response = await api.get(`Document/Exercices2/${numcont}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };

  getMonthConsoByPart = async (numcont) => {

    try {
      const response = await api.get(`Participant/MonthConso/ByPart/${numcont}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      throw error;
    }
  }

  getSoldePart = async (numcont) => {
    try {
      const response = await api.get(`Participant/Miliri/GetSoldePart/${numcont}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      throw error;
    }
  };

  getDocsPart = async (numcont, year) => {
    try {
      const response = await api.get(`Document/ByPartExt?matricule=${numcont}&annee=${year}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      throw error;
    }
  };
  getSituationPart = async (numcont, selectedYear) => {
    try {
      const response = await api.get(`Compta/Participant/Conso?matricule=${numcont}&annee=${selectedYear}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };
  getComptaExercice = async (numcont) => {
    try {
      const response = await api.get(`Compta/Exercices2/${numcont}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };
  //Get One Adherent
  getAdherent = async (id) => {
    try {
      const response = await api.get(`Adherent/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'adherent :', error);
      throw error;
    }
  }


  /* .......................................................................... */
  //les impressions
  printParticipComptService = (numcont, selectedYear) => {

    const url = `${api_URL}Print/ExtraitDeCompte/${numcont}/${selectedYear}?docName=extraitcptepart`;

    fetch(url, {
      method: 'GET',
      /*  headers: {
         'user_id': userId,
         'username': username,  
       }, */
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  printDocumentService = (numdoc, numcont) => {

    const url = `${api_URL}Print/Document2/${numdoc}/${numcont}`;

    fetch(url, {
      method: 'GET',

    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };

  /* .......................................................................... */
  getDocsPart = async (numcont, selectedYear) => {
    try {
      const response = await api.get(`Document/ByPartExt?matricule=${numcont}&annee=${selectedYear}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };
  getDocExercice = async (numcont) => {
    try {
      const response = await api.get(`Document/Exercices2/${numcont}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };

  getBenef = async (numcont) => {
    try {
      const response = await api.get(`Benef/list/${numcont}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };
  //
  getFournisseurs = async () => {
    try {
      const response = await api.get(`Fournisseur/list`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };
  //
  getTypeDoc = async (numcont) => {
    try {
      const response = await api.get(`Document/getTypeDoc/${numcont}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };
  getPrestation = async () => {
    try {
      const response = await api.get(`Prestations/list`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };

  getTypeBenef = async () => {
    try {
      const response = await api.get(`Benef/typeBenef/list`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des benefs :', error);
      throw error;
    }
  };
  //
  getSpecialites = async () => {
    try {
      const response = await api.get(`Specialites/list`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };

  addDoc = async (payload) => {
    try {
      const response = await api.post(`Document/IPM/add`, payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };

  updateDoc = async (payload) => {
    try {
      const response = await api.put(`Document/IPM/updateBefore`, payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };
  deleteDoc = async (numdoc, numcont) => {
    try {
      const response = await api.delete(`Document/delete/${numdoc}/IPM/${numcont}`,);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des photos :', error);
      throw error;
    }
  };

  ///Document/delete/LGI000212/IPM/001-3121
}